'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLOSE_SOURCES = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLOSE_SOURCES = exports.CLOSE_SOURCES = {
  BACKDROP: 1,
  CLOSE_BUTTON: 2,
  ESCAPE: 3,
  ITEM_CLICK: 4
};

exports.default = function () {
  var decoratorConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
      (0, _inherits3.default)(ComponentAsModal, _React$Component);

      function ComponentAsModal() {
        (0, _classCallCheck3.default)(this, ComponentAsModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ComponentAsModal.__proto__ || (0, _getPrototypeOf2.default)(ComponentAsModal)).call(this));

        _this.state = {
          belowOverlay: false
        };
        _this.handleToggleHide = _this.handleToggleHide.bind(_this);
        _this.handleAllClicks = _this.handleAllClicks.bind(_this);
        _this.handleCloseClick = _this.handleCloseClick.bind(_this);
        _this.handleBackdropClick = _this.handleBackdropClick.bind(_this);
        return _this;
      }

      (0, _createClass3.default)(ComponentAsModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (__CLIENT__ || __TEST__) {
            this.escListener = this.handleEscKeypress.bind(this);
            document.addEventListener('keydown', this.escListener);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if ((__CLIENT__ || __TEST__) && this.escListener) {
            document.removeEventListener('keydown', this.escListener);
          }
        }
      }, {
        key: 'handleBackdropClick',
        value: function handleBackdropClick() {
          var onModalClose = this.props.onModalClose;


          if (onModalClose) {
            onModalClose(CLOSE_SOURCES.BACKDROP);
          }
        }
      }, {
        key: 'handleCloseClick',
        value: function handleCloseClick() {
          var onModalClose = this.props.onModalClose;


          if (onModalClose) {
            onModalClose(CLOSE_SOURCES.CLOSE_BUTTON);
          }
        }
      }, {
        key: 'handleEscKeypress',
        value: function handleEscKeypress(event) {
          var onModalClose = this.props.onModalClose;


          if (event.keyCode === 27) {
            if (onModalClose && !decoratorConfig.isPersistent) {
              onModalClose(CLOSE_SOURCES.ESCAPE);
            }
          }
        }
      }, {
        key: 'handleAllClicks',
        value: function handleAllClicks(event) {
          var onModalClose = this.props.onModalClose;


          if (event && event.target) {
            var target = event.target;

            while (target) {
              if (target.classList && target.classList.contains('modal__closer')) {
                if (onModalClose) {
                  onModalClose(CLOSE_SOURCES.ITEM_CLICK);
                }
                return;
              }
              target = target.parentNode;
            }
          }
        }
      }, {
        key: 'handleToggleHide',
        value: function handleToggleHide() {
          var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

          this.setState({ belowOverlay: val });
        }
      }, {
        key: 'render',
        value: function render() {
          var modalConfig = this.props.modalConfig;

          var config = (0, _extends3.default)({}, decoratorConfig, modalConfig);

          return _react2.default.createElement(
            'div',
            { onClick: !config.isPersistent ? this.handleAllClicks : undefined },
            _react2.default.createElement(
              'div',
              {
                className: (0, _classnames2.default)('modal', config.headerClass, {
                  'modal--no-scrollbar': config.hideScrollbar,
                  'modal--below-overlay': this.state.belowOverlay,
                  'modal--center-vertically': config.centerVertically
                })
              },
              _react2.default.createElement(
                'div',
                {
                  className: (0, _classnames2.default)('modal__dialog', {
                    'modal__dialog--center-vertically': config.centerVertically
                  })
                },
                !config.isPersistent && !config.hideClose && _react2.default.createElement(
                  'a',
                  {
                    className: (0, _classnames2.default)('modal__close m', {
                      'modal__close--light': config.lightClose
                    }),
                    onClick: !config.isPersistent ? this.handleCloseClick : undefined
                  },
                  'Close'
                ),
                _react2.default.createElement(
                  'div',
                  { className: (0, _classnames2.default)('modal__border', config.modalBorderClass) },
                  _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)('modal__content', config.modalContentClass) },
                    _react2.default.createElement(Component, (0, _extends3.default)({}, this.props, { onToggleHide: this.handleToggleHide }))
                  )
                )
              )
            ),
            _react2.default.createElement('div', {
              className: (0, _classnames2.default)('modal__backdrop', config.backdropClass),
              onClick: !config.isPersistent ? this.handleBackdropClick : undefined
            })
          );
        }
      }]);
      return ComponentAsModal;
    }(_react2.default.Component), _class.displayName = 'Modal(' + (Component.displayName || Component.name) + ')', _class.propTypes = {
      modalConfig: _propTypes2.default.shape({
        backdropClass: _propTypes2.default.string,
        centerVertically: _propTypes2.default.bool,
        headerClass: _propTypes2.default.string,
        hideClose: _propTypes2.default.bool,
        hideScrollbar: _propTypes2.default.bool,
        isPersistent: _propTypes2.default.bool,
        lightClose: _propTypes2.default.bool,
        modalBorderClass: _propTypes2.default.string,
        modalContentClass: _propTypes2.default.string
      }),
      onModalClose: _propTypes2.default.func
    }, _temp;
  };
};